class d {
  static set(c, e, t) {
    t = t || {};
    let o = t.expires;
    if (typeof o == "number" && o) {
      const r = /* @__PURE__ */ new Date();
      r.setTime(r.getTime() + o * 1e3), o = t.expires = r;
    }
    o && o.toUTCString && (t.expires = o.toUTCString()), e = encodeURIComponent(e);
    let i = c + "=" + e, n;
    for (n in t) {
      i += "; " + n;
      const r = t[n];
      r !== !0 && (i += "=" + r);
    }
    document.cookie = i;
  }
  static get(c) {
    const e = document.cookie.match(
      new RegExp(
        "(?:^|; )" + c.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"
      )
    );
    return e != null && e[1] ? decodeURIComponent(e[1]) : "";
  }
}
function g(p) {
  return d.get(p);
}
export {
  g as getCookie
};
